<template>
  <div class="bg-white border shadow sm:rounded-lg flex flex-col">
    <div v-if="title || useTitleIcon"
         class="bg-white px-4 py-2 border-b sm:rounded-t-lg border-gray-200 sm:px-6 md:flex md:items-center md:justify-between"
    :class="titleClass">
      <div v-if="useTitleIcon" class="h-8">
        <slot name="titleIcon"></slot>
      </div>
      <h3 class="text-lg leading-6 font-medium py-3 text-gray-900">
        {{ title }}
      </h3>

      <div v-if="$slots.actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <div :class="contentBoxClass">
      <slot></slot>
    </div>
    <div v-if="$slots['buttons']"
         class="bg-gray-100 flex-1 sm:rounded-b-lg border-t border-gray-200 px-4 py-4 sm:px-6">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>
<script>

export default {
    name: "panel",
    props: {
        noPadding: {type: Boolean, default: false},
        title: {type: String},
        useTitleIcon: {type: Boolean, default: false},
        contentClass: {type: String, default: ""},
        titleClass: {type: String, default:""}
    },
    computed: {
      contentBoxClass() {
          return this.noPadding ? this.contentClass : this.contentClass + ' px-4 py-5 sm:p-6'
        }
    }
}
</script>